import { defineComponent } from 'vue';
import { toSizeUnit } from '../utils/elements';
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = n => (_pushScopeId(""), n = n(), _popScopeId(), n);

var _hoisted_1 = {
  class: "var-table var-elevation--1 var--box"
};
var _hoisted_2 = {
  class: "var-table__main"
};
var _hoisted_3 = {
  key: 0,
  class: "var-table__footer"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("table", {
    class: "var-table__table",
    style: _normalizeStyle({
      width: _ctx.toSizeUnit(_ctx.fullWidth)
    })
  }, [_renderSlot(_ctx.$slots, "default")], 4
  /* STYLE */
  )]), _ctx.$slots.footer ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "footer")])) : _createCommentVNode("v-if", true)]);
}
export default defineComponent({
  render,
  name: 'VarTable',
  props: {
    fullWidth: {
      type: [Number, String],
      default: '100%'
    }
  },

  setup() {
    return {
      toSizeUnit
    };
  }

});